module.exports = __webpack_public_path__ + "static/b_s-7b496ad04c76df5f0d2eba64044031f0.svg";